import { TranslateService } from '@ngx-translate/core';
import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@app/app.routing';

import { EChartsOption } from 'echarts';
import { initChartOptions } from './chart-config';

@Component({
  selector: 'clicks-on-google',
  templateUrl: './clicks-on-google.component.html',
  styleUrls: ['./clicks-on-google.component.scss'],
  standalone: false,
})
export class ClicksOnGoogleComponent implements OnChanges {
  @Output() retryEmitter = new EventEmitter<void>();
  @Input() dataCheckFailed: boolean;
  @Input() loading: boolean;
  @Input() googleMetrics: any;
  chartData: EChartsOption;
  options: any;
  totalCount: number;

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService
  ) {}

  ngOnChanges(): void {
    if (this.googleMetrics) {
      this.initChart();
    }
  }

  viewDetails(): void {
    this.router.navigate([AppRoutes.REVIEWS]);
  }

  retry(): void {
    this.retryEmitter.emit();
  }

  initChart(): void {
    const { metrics } = this.googleMetrics;
    const t = metrics.find(googleMetrics => googleMetrics.name === 'ACTIONS_WEBSITE').data;
    const xAxisData: string[] = t.map((rating: any) => {
      return `  ${rating.period.substring(5)}   `;
    });

    this.totalCount = metrics[0].totalCount + metrics[1].totalCount + metrics[2].totalCount;

    const data1 = metrics.find(googleMetrics => googleMetrics.name === 'ACTIONS_WEBSITE').data.map(d => d.count);
    const data2 = metrics.find(googleMetrics => googleMetrics.name === 'ACTIONS_PHONE').data.map(d => d.count);
    const data3 = metrics.find(googleMetrics => googleMetrics.name === 'ACTIONS_DRIVING_DIRECTIONS').data.map(d => d.count);

    const yAxisData: number[] = metrics.map((rating: any) => rating.number);
    const translations = [
      this.translate.instant('csa.clicks.google.directions'),
      this.translate.instant('csa.clicks.google.website'),
      this.translate.instant('csa.clicks.google.phone'),
    ];
    this.chartData = initChartOptions(xAxisData, yAxisData, data1, data2, data3, translations);
  }
}
